export default (response) => (response?.success ? response : ({
  ...response,
  bonusFundsEligible: true,
}));
